import React from "react";
import { MessageCircle, Check, RefreshCw } from "lucide-react";
import { RateAutomationCard } from "./RateAutomationCard";

/**
 * AdminDivisaTab — daily USD/Bs exchange rate + WhatsApp support number.
 *
 * Two independent cards. Save handlers live in the parent App because they
 * touch shared refresh flows (rateInput -> exchangeRate everywhere; support
 * number -> global settings).
 */
export function AdminDivisaTab({
  rateInput,
  setRateInput,
  onSaveRate,
  supportWhatsappInput,
  setSupportWhatsappInput,
  supportWhatsapp,
  savingSupportWa,
  onSaveSupportWhatsapp,
  showToast,
  onRateChanged,
  activeRate,
}) {
  return (
    <div className="max-w-xl mx-auto space-y-6">
      <div className="rounded-3xl bg-ag7-surface border border-[var(--ag7-border-soft)] p-8 space-y-6">
        <h3 className="text-xl font-heading font-extrabold tracking-tight text-white mb-1">Configuración de Divisa (Tasa del Día)</h3>
        <p className="text-xs text-zinc-400">La tasa aplica a todos los precios USD → Bs mostrados al cliente. Si la editas aquí queda en modo MANUAL.</p>
        <div>
          <label className="block text-xs font-mono text-zinc-400 mb-2">1 USD = Bs</label>
          <div className="flex gap-3">
            <input
              type="number"
              step="0.01"
              data-testid="exchange-rate-input"
              value={rateInput}
              onChange={(e) => setRateInput(e.target.value)}
              className="flex-1 min-w-0 bg-ag7-bg border border-[var(--ag7-border-soft)] rounded-xl px-4 py-3 text-white text-xl font-mono font-bold focus:outline-none focus:border-cyan-500"
            />
            <button
              onClick={onSaveRate}
              data-testid="save-rate-btn"
              className="flex-shrink-0 bg-cyan-600 hover:bg-cyan-500 text-white font-bold px-6 py-3 rounded-xl text-xs"
            >
              Guardar
            </button>
          </div>
        </div>
      </div>

      <RateAutomationCard showToast={showToast} onRateChanged={onRateChanged} activeRate={activeRate} />

      <div className="rounded-3xl bg-ag7-surface border border-[var(--ag7-border-soft)] p-8 space-y-4">
        <div className="flex items-center gap-2">
          <div className="w-9 h-9 rounded-full bg-green-950/60 border border-green-500 flex items-center justify-center">
            <MessageCircle className="w-5 h-5 text-green-400" fill="currentColor" strokeWidth={0} />
          </div>
          <div>
            <h3 className="text-xl font-heading font-extrabold tracking-tight text-white">WhatsApp de Soporte</h3>
            <p className="text-[11px] text-zinc-400">Número al que se enviarán los reportes de los clientes desde el botón flotante.</p>
          </div>
        </div>
        <div>
          <label className="block text-[10px] font-mono uppercase tracking-widest text-zinc-400 mb-2">
            Número (formato internacional, sin &apos;+&apos;)
          </label>
          <div className="flex gap-3">
            <input
              type="text"
              inputMode="tel"
              data-testid="support-whatsapp-input"
              value={supportWhatsappInput}
              onChange={(e) => setSupportWhatsappInput(e.target.value)}
              placeholder="Ej. 584145559988"
              className="flex-1 min-w-0 bg-ag7-bg border border-[var(--ag7-border-soft)] rounded-xl px-4 py-3 text-white text-lg font-mono font-bold focus:outline-none focus:border-green-500"
            />
            <button
              onClick={onSaveSupportWhatsapp}
              disabled={savingSupportWa}
              data-testid="save-support-whatsapp-btn"
              className="flex-shrink-0 bg-green-600 hover:bg-green-500 disabled:opacity-40 text-white font-bold px-6 py-3 rounded-xl text-xs flex items-center gap-2"
            >
              {savingSupportWa ? <RefreshCw className="w-4 h-4 animate-spin" /> : <Check className="w-4 h-4" />}
              <span>Guardar</span>
            </button>
          </div>
          <p className="text-[10px] font-mono text-zinc-500 mt-2">
            Actual: <span className="text-green-300">+{supportWhatsapp}</span> · Ejemplo Venezuela: 58414XXXXXXX (8-15 dígitos)
          </p>
        </div>
      </div>
    </div>
  );
}
